import React, { Component } from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex";
import MappingListOutput from "./../Micro/MappingListOutput.js";
import { reverseLoopItSelf, loopItSelf } from "./../Global/tools.js";

import { ReactComponent as ArrowRight } from "../Global/Icons/arrowR.svg";
import { ReactComponent as ArrowLeft } from "../Global/Icons/arrowL.svg";

const multiple = nota.global.multiple;

const StyledGrid = styled.div`
  width: 100%;
  .grid {
    display: grid;
    grid-gap: 0px; /* 4px */
    grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));

    grid-auto-flow: row;
    grid-auto-rows: 0px;
    grid-column-gap: 0px;
    grid-template-rows: repeat(${(props) => props.row}, auto);
    /* overflow: hidden; */
  }

  .arrowWrapper {
    width: 20px;
    height: 100%;
    cursor: pointer;
    user-select: none;
    margin-bottom: ${(props) => (props.row > 1 ? "0" : "40")}px;
  }
`;

class Grid extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
    };
    this.container = React.createRef();

    this.intervalLoop = null;
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("resize", this.onResize, false);

    if (this.props.isCarrosel) {
      this.initializeLoop();
    }

    if (this.container.current) {
      let previousWidth = this.container.current.offsetWidth;

      const ro = new ResizeObserver((entries) => {
        const entry = entries[0];
        const newWidth = entry.contentRect.width;

        if (previousWidth !== newWidth) {
          this.forceUpdate();
        }

        previousWidth = newWidth;
      });

      ro.observe(this.container.current);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ data: this.props.data });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("resize", this.onResize, false);
    this.container.current.removeEventListener("resize", this.onResize, false);
  }

  onResize = () => {
    console.log("Resize");
    this.forceUpdate();
  };

  onMouseEnterHandler = () => {
    if (this.props.isCarrosel) {
      this.killLoop();
    }
  };

  onMouseLeaveHandler = () => {
    if (this.props.isCarrosel) {
      this.initializeLoop();
    }
  };

  initializeLoop = () => {
    if (!this.intervalLoop) {
      this.intervalLoop = setInterval(this.onLeftArrowHandler, 3500);
    }
  };

  killLoop = () => {
    if (this.intervalLoop) {
      clearInterval(this.intervalLoop);
      this.intervalLoop = null;
    }
  };

  onLeftArrowHandler = () => {
    this.setState({ data: reverseLoopItSelf(this.state.data) });
  };

  onRightArrowHandler = () => {
    this.setState({ data: loopItSelf(this.state.data) });
  };

  getData = () => {
    if (this.container.current && this.state.data) {
      let gridElement = this.container.current.querySelector(".grid");
      let cardSize = Number(gridElement ? window.getComputedStyle(gridElement, null).getPropertyValue("grid-template-columns").split(" ")[0].slice(0, -2) : null);
      if (cardSize == null || cardSize < 0 || isNaN(cardSize)) cardSize = 225;

      if ((this.container.current?.clientWidth ?? 0) > 0) this.defaultWidth = this.container.current?.clientWidth;

      let margin = 0;
      if (this.props.isCarrosel) margin = 40;

      let totalCards = Math.floor((this.defaultWidth - margin) / cardSize);
      return this.state.data.filter((v, i) => i < totalCards * this.props.row);
    } else {
      //Force Update if no current element
      if (!this.container.current) {
        this.forceUpdate();
      }
    }

    return this.state.data;
  };

  render() {
    if (!this.state.data) return null;

    return (
      <NanoFlex className="gridWrapper" ref={this.container} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
        <StyledGrid row={this.props.row}>
          <NanoFlex className="gridCarouselWrapper" flex={"wrap"} flex-direction={"row"} justifyContent={"space-between"}>
            {this.props.isCarrosel && (
              <NanoFlex className="arrowWrapper">
                <ArrowLeft style={{ width: "20px", height: "20px" }} onClick={this.onRightArrowHandler} />
              </NanoFlex>
            )}
            <NanoFlex className="grid" flexWrap={"wrap"} justifyContent={"flex-start"} alignItems={"flex-start"}>
              <MappingListOutput data={this.getData()} isLoadingDone={true} type={this.props.type} />
            </NanoFlex>
            {this.props.isCarrosel && (
              <NanoFlex className="arrowWrapper">
                <ArrowRight style={{ width: "20px", height: "20px" }} onClick={this.onLeftArrowHandler} />
              </NanoFlex>
            )}
          </NanoFlex>
        </StyledGrid>
      </NanoFlex>
    );
  }
}

// Set default props
Grid.defaultProps = { data: null };

export default Grid;

// --- // Documentation // --- //
/*

import Grid from './../Macro/Grid.js';

<Grid data={null} />
*/
